import React, { Component } from 'react'

export default class Button extends Component {
    render() {
        const { icon,ricon, title, className, titleClassName, ...props } = this.props

        return (
            <button className={`group flex items-center justify-center py-3 px-6 flex-row gap-3 rounded-xl bg-[#130D0D] ${!icon && 'lg:hover:bg-[#F89A1F]'}  transition-all stroke-[#F89A1F] hover:stroke-white  disabled:hover:bg-[#130D0D] ${className}`}
                {...props}
            >
                {icon && <img className='w-4 transition-all' src={icon} alt={title}/>}
                {ricon && (ricon)}
                {title && <span className={`font-medium text-sm text-white ${titleClassName}`}>{title}</span>}
            </button>
        )
    }
}
